import styled from "styled-components";
import boxMixin from "../../../mixins/box";
import isPropValid from "@emotion/is-prop-valid";
export const Item = styled.a.withConfig({
    shouldForwardProp: isPropValid,
}) `
  ${boxMixin};
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSXRlbS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0JyZWFkY3J1bWJOYXZpZ2F0aW9uL3N0eWxlZC9JdGVtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sTUFBTSxNQUFNLG1CQUFtQixDQUFDO0FBQ3ZDLE9BQU8sUUFBUSxNQUFNLHFCQUFxQixDQUFDO0FBQzNDLE9BQU8sV0FBVyxNQUFNLHdCQUF3QixDQUFDO0FBRWpELE1BQU0sQ0FBQyxNQUFNLElBQUksR0FBRyxNQUFNLENBQUMsQ0FBQyxDQUFDLFVBQVUsQ0FBQztJQUN0QyxpQkFBaUIsRUFBRSxXQUFXO0NBQy9CLENBQUMsQ0FBQTtJQUNFLFFBQVE7Q0FDWCxDQUFDIn0=